import { useQuery } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";
import { BankAccount } from "../../types/Contact";

export const getMyBankAccount = (options: APQueryOptions = {}) => {
  const { fetchWithAuth } = useApi();
  const { isQueryEnabled } = useAPQuery();

  return useQuery({
    queryKey: ["bankAccount"],
    queryFn: (): Promise<BankAccount | null> => {
      return fetchWithAuth<BankAccount | null>("getMyBankAccount");
    },
    enabled: isQueryEnabled(options),
  });
};
